import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconName } from '../../icons-container/icons.type';
import { BadgeColor } from './badge.types';
@Component({
  selector: 'rt-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'color',
  },
})
export class BadgeComponent {
  @Input() public color: BadgeColor;
  @Input() public iconName: IconName;
  @Input() public text: string | number;
}
